import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { NgForm, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { AuthenticationService } from "@app/authentication/services/authentication.service";
import { ConfirmationModalComponent } from "@components/confirmation-modal/confirmation-modal.component";
import { Router } from "@angular/router";
import { Log } from "ng2-logger";
import { TranslateService } from "@ngx-translate/core";
import { ToastsManager } from "@app/shared/util/toastr.service";

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {
    _logger = Log.create(ForgotPasswordComponent.name);
    @ViewChild(ConfirmationModalComponent, {static: false}) confirmationModal: ConfirmationModalComponent;
    @ViewChild('form', {static: false}) form: ElementRef;

    inputDisabled = false;

    forgotPasswordForm: UntypedFormGroup;
    showValidations = false;
    forgotPasswordError: boolean;
    isLoading: boolean;
    boschId: string;

    constructor(private authService: AuthenticationService,
                private formBuilder: UntypedFormBuilder,
                private router: Router,
                private translate: TranslateService,
                private toastr: ToastsManager) {

        this.forgotPasswordForm = this.formBuilder.group({
            'password': ['', Validators.required],
            'passwordConfirmation': ['', Validators.required]
        });

    }

    onConfirmForgotPassword(event) {
        this.boschId = event.boschId;

        const formData = {
            boschId: event.boschId,
            formValues: this.forgotPasswordForm.value
        };

        this.inputDisabled = false;

        this.authService.forgotPassword(formData).subscribe(
            (data: any) => {
                this._logger.info('handleForgotPassword:: API returned data: ', data);
                this.toastr.info(this.translate.instant('auth.toasts.passwordChangeSuccess'));
                this.router.navigate(['/auth']);
                this.confirmationModal.close();
            },
            (error: any) => {
                this._logger.error('handleForgotPassword:: API returned error: ', error);
                this.confirmationModal.close();
            });
    }

    onSubmitForgotPassword() {
        if (!this.forgotPasswordForm.valid) {
            this.showValidations = true;
            return;
        }

        if (!this.validatePasswordMatch()) {
            this.showValidations = true;
            return;
        }

        this.showValidations = false;
        this.inputDisabled = true;
        this.confirmationModal.open();
    }

    private validatePasswordMatch() {
        const password = this.forgotPasswordForm.value.password;
        const confirmPassword = this.forgotPasswordForm.value.passwordConfirmation;

        if (password !== confirmPassword) {
            this.forgotPasswordError = true;
            this.forgotPasswordForm.reset();
        } else {
            return true;
        }
    }

    @HostListener('document:click')
    onEnableInput() {
        this.inputDisabled = false;
    }

    resetMissmatchError() {
        this.forgotPasswordError = false;
    }
}
